export default __webpack_public_path__ + "static/media/section-3-right-1.455a495d.png";